import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store.ts